import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

const CompressionSwitch = ({ handleSwitch, ...restOfProps }) => {
    return (
        <FormControlLabel
            control={<Switch onClick={() => handleSwitch()} />}
            label="Compress"
        />
    );
};

export default CompressionSwitch;
